import React from 'react';
import { motion } from 'framer-motion';
interface PageHeroProps {
  eyebrow: string;
  title: string;
  description: string;
}
export function PageHero({
  eyebrow,
  title,
  description
}: PageHeroProps) {
  return <section className="relative bg-stark-white pt-32 pb-16 md:pt-40 md:pb-20 border-b border-midnight-navy/10 overflow-hidden" data-id="element-168" data-mp="3tavcdveyrmw7">
      <div aria-hidden="true" className="absolute top-0 right-0 w-[40%] h-full bg-cool-gray -skew-x-12 translate-x-40 pointer-events-none" data-id="element-169" data-mp="23r7p76akcqy" />
      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-170" data-mp="usfzugpdd7qk">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-3xl space-y-6" data-id="element-171" data-mp="uu0xif6zd6sn">
          <span className="text-royal-blue text-xs font-bold uppercase tracking-[0.2em]" data-id="element-172" data-mp="1die9h18tf8wb">
            {eyebrow}
          </span>
          <h1 className="text-midnight-navy text-4xl md:text-6xl font-montserrat font-extrabold leading-[1.05] tracking-tight" data-id="element-173" data-mp="32jdeaaekcz70">
            {title}
          </h1>
          <p className="text-midnight-navy/60 text-lg md:text-xl leading-relaxed" data-id="element-174" data-mp="3c7veapf0r29l">
            {description}
          </p>
        </motion.div>
      </div>
    </section>;
}